import $ from "jquery";

import {
  bindSearchDropdowns,
} from '../helper_modules/select2_form_helpers';

const searchFormElements = {
  dropdowns: $(`.search-box-field`),
};

export default class Zones {
  constructor() {
    this.searchFormElements = searchFormElements;
    this.bindElements();
  }

  static init() {
    if ($(`.zones.edit`).length === 0) {
      return;
    }

    return new Zones();
  }

  bindElements() {
    bindSearchDropdowns(this.searchFormElements);
  }
}
